import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Spinner, SpinnerSize } from '../spinner/Spinner';
import Symbol, { SymbolDirection } from '../symbol/Symbol';
import * as styles from './Select.style';
import { ICON_CHEVRON } from '../../icons';
export const Select = _ref => {
  let {
    id,
    name,
    disabled,
    value,
    required,
    options,
    valid,
    error,
    onChange,
    onBlur,
    onFocus,
    dataRef,
    loading,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.wrapper
  }, loading && /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css2: styles.loading
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: SpinnerSize.SMALLER,
    color: "neutrals.medium"
  })), /*#__PURE__*/React.createElement(_StyledSelect, _extends({
    id: id,
    name: name,
    value: value || '',
    disabled: disabled,
    required: required,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    "aria-required": required,
    "aria-disabled": disabled || loading,
    $valid: valid,
    $error: error,
    "data-ref": `${dataRef}-input`
  }, rest, {
    $_css3: styles.select
  }), options.map((option, index) => /*#__PURE__*/React.createElement("option", {
    // eslint-disable-next-line react/no-array-index-key
    key: index,
    value: option.value,
    disabled: option.disabled
  }, option.label))), /*#__PURE__*/React.createElement(_StyledDiv2, {
    disabled: disabled || loading,
    $_css4: styles.icon
  }, /*#__PURE__*/React.createElement(Symbol, {
    path: ICON_CHEVRON,
    direction: SymbolDirection.BOTTOM,
    size: 18
  })));
};
Select.defaultProps = {
  dataRef: 'select'
};
export default Select;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Select___StyledDiv",
  componentId: "sc-1akot64-0"
})(["", ""], p => p.$_css);
var _StyledSpan = _styled("span").withConfig({
  displayName: "Select___StyledSpan",
  componentId: "sc-1akot64-1"
})(["", ""], p => p.$_css2);
var _StyledSelect = _styled("select").withConfig({
  displayName: "Select___StyledSelect",
  componentId: "sc-1akot64-2"
})(["", ""], p => p.$_css3);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "Select___StyledDiv2",
  componentId: "sc-1akot64-3"
})(["", ""], p => p.$_css4);
//# sourceMappingURL=Select.js.map